// extracted by mini-css-extract-plugin
export default {"container":"notification_link_date-module__container--2HZeJ"};